// @flow
import { CategoriesTravelActionTypes } from './constants';

type CategoriesTravelAction = { type: string, payload: {} | string };

// common success
export const categoriesTravelApiResponseSuccess = (actionType: string, data: any): CategoriesTravelAction => ({
    type: CategoriesTravelActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const categoriesTravelApiResponseError = (actionType: string, error: string): CategoriesTravelAction => ({
    type: CategoriesTravelActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getCategoryTravel = (id: string): CategoriesTravelAction => ({
    type: CategoriesTravelActionTypes.GET_CATEGORY_TRAVEL,
    payload: { id },
});

export const addCategoryTravel = (categoryTravel:any):CategoriesTravelAction=>({
    type:CategoriesTravelActionTypes.ADD_CATEGORY_TRAVEL,
    payload:categoryTravel
})
export const updateCategoryTravel = (categoryTravel:any):CategoriesTravelAction=>({
    type:CategoriesTravelActionTypes.UPDATE_CATEGORY_TRAVEL,
    payload:categoryTravel
})
export const deleteCategoryTravel = (id:string):CategoriesTravelAction=>({
    type:CategoriesTravelActionTypes.DELETE_CATEGORY_TRAVEL,
    payload:{id}
})

export const listCategoriesTravel = (params:any): CategoriesTravelAction => ({
    type: CategoriesTravelActionTypes.LIST_CATEGORIES_TRAVEL,
    payload: params,
});


export const resetCategoriesTravel = (): CategoriesTravelAction => ({
    type: CategoriesTravelActionTypes.RESET,
    payload: {},
});

